module.exports = __webpack_public_path__ + "img/1.ed3ef560.jpeg";